var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconUnmerge = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M13.6,26c-1.2,0-2.2-1-2.2-2.2V18H6.6c-1.2,0-2.2-1-2.2-2.2V6.1c0-1.2,1-2.2,2.2-2.2\n\th9.8c1.2,0,2.2,1,2.2,2.2V12h4.8c1.2,0,2.2,1,2.2,2.2v9.8c0,1.2-1,2.2-2.2,2.2H13.6z" }),
            React.createElement("g", { transform: "translate(-582.715 -586.473)" },
                React.createElement("g", { transform: "translate(594.116 599.056)" },
                    React.createElement("path", { d: "M4.6,8.8H10V3.4" }),
                    React.createElement("path", { d: "M10,8.8L3.5,2.3" })),
                React.createElement("path", { d: "M596.7,595.1h-5.4v5.4" }),
                React.createElement("path", { d: "M591.3,595.1l6.5,6.5" })))));
});
export default IconUnmerge;
//# sourceMappingURL=IconUnmerge.js.map